import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin: 20px auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Arrow = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #707070;
`;

export const Label = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  padding: 16px 12px;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: ${({ selected, theme }) => selected ? theme.colors.primary + '10' : '#fff'};
  border: ${({ selected, theme }) => selected ? '1px solid ' + theme.colors.primary : '1px solid #E7E7E7'};
  border-radius: 10px;

  &:hover {
    background-color: #E7E7E7;
  }
`;
